import Aiden_Wu from "../../styles/results/img/speakers/Aiden_Wu.webp";
import Aksakov_Anatoly_Gennadievich from "../../styles/results/img/speakers/Aksakov_Anatoly_Gennadievich.webp";
import Alafinov_Innokenty_Sergeevich from "../../styles/results/img/speakers/Alafinov_Innokenty_Sergeevich.webp";
import Alexander_Stolyarov from "../../styles/results/img/speakers/Alexander_Stolyarov.webp";
import Bakanov_Dmitry_Vladimirovich from "../../styles/results/img/speakers/Bakanov_Dmitry_Vladimirovich.webp";
import Chernikov_Mikhail_Yuryevich from "../../styles/results/img/speakers/Chernikov_Mikhail_Yuryevich.webp";
import Dvorkovich_Arkady_Vladimirovich from "../../styles/results/img/speakers/Dvorkovich_Arkady_Vladimirovich.webp";
import Dyubanov_Anatoly_Vasilievich from "../../styles/results/img/speakers/Dyubanov_Anatoly_Vasilievich.webp";
import Guzairov_Aidar_Failevich from "../../styles/results/img/speakers/Guzairov_Aidar_Failevich.webp";
import Jakob_Bangsgaard from "../../styles/results/img/speakers/Jakob_Bangsgaard.webp";
import Kaem_Kirill_Vladimirovich from "../../styles/results/img/speakers/Kaem_Kirill_Vladimirovich.webp";
import Marina_Alekseevna_Zhunich from "../../styles/results/img/speakers/Marina_Alekseevna_Zhunich.webp";
import Nashchekin_Alexey_Sergeevich from "../../styles/results/img/speakers/Nashchekin_Alexey_Sergeevich.webp";
import Nurutdinov_Airat_Rafkatovich from "../../styles/results/img/speakers/Nurutdinov_Airat_Rafkatovich.webp";
import Ordzhonikidze_Grigory_Eduardovich from "../../styles/results/img/speakers/Ordzhonikidze_Grigory_Eduardovich.webp";
import Orlovsky_Viktor_Mikhailovich from "../../styles/results/img/speakers/Orlovsky_Viktor_Mikhailovich.webp";
import Shadayev_Maksut_Igorevich from "../../styles/results/img/speakers/Shadayev_Maksut_Igorevich.webp";
import Skorobogatova_Olga_Nikolaevna from "../../styles/results/img/speakers/Skorobogatova_Olga_Nikolaevna.webp";
import Urazov_Robert_Nailevich from "../../styles/results/img/speakers/Urazov_Robert_Nailevich.webp";
import Vitaliy_Terentyev from "../../styles/results/img/speakers/Vitaliy_Terentyev.webp";
import Zhou_Danjin from "../../styles/results/img/speakers/Zhou_Danjin.webp";

import Abakumov_Evgeniy_Mikhailovich from "../../styles/results/img/speakers/Abakumov_Evgeniy_Mikhailovich.webp";
import Prepodobnaya_Nadezhda_Aleksandrovna from "../../styles/results/img/speakers/Prepodobnaya_Nadezhda_Aleksandrovna.webp";
import Sergiyenkov_Dmitriy_Sergeyevich from "../../styles/results/img/speakers/Sergiyenkov_Dmitriy_Sergeyevich.webp";
import Shpak_Vasiliy_Viktorovich from "../../styles/results/img/speakers/Shpak_Vasiliy_Viktorovich.webp";
import Alekseeva_Zhanna_Vladimirovna from "../../styles/results/img/speakers/Alekseeva_Zhanna_Vladimirovna.webp";
import Omelchuk_Andrey_Vladimirovich from "../../styles/results/img/speakers/Omelchuk_Andrey_Vladimirovich.webp";
import Akhmerov_Timur_Maratovich from "../../styles/results/img/speakers/Akhmerov_Timur_Maratovich.webp";
import Kulik_Vadim_Valerievich from "../../styles/results/img/speakers/Kulik_Vadim_Valerievich.webp";
import Kaspersky_Evgeny_Valentinovich from "../../styles/results/img/speakers/Kaspersky_Evgeny_Valentinovich.webp";
import Zelenskiy_Vladimir from "../../styles/results/img/speakers/Zelenskiy_Vladimir.webp";

import MishustinColor from "../../styles/results/img/speakers/Mishustin_Mikhail.webp";
import ChernishenkoColor from "../../styles/results/img/speakers/Chernishenko_Dmitry.webp";
import KhusnullinColor from "../../styles/results/img/speakers/Khusnullin_Marat.webp";
import MinnikhanovColor from "../../styles/results/img/speakers/Minnikhanov_Rustam.webp";
import { stringKeys } from "../../components/Results/types/common";

const MINNIHAKHANOV = {
    photo: { file: MinnikhanovColor, name: "Rustam Minnikhanov" },
    full_name: "Минниханов Рустам Нургалиевич",
    surname_en: "Minnikhanov",
    name_en: "Rustam",
    lastname_en: "",
    work_position: "Глава (Раис) Республики Татарстан",
    work_position_en: "Head (Rais) of the Republic of Tatarstan",
    place_of_work: "",
    place_of_work_en: "",
};

const CHERNIKOV = {
    photo: { file: Chernikov_Mikhail_Yuryevich, name: "Chernikov_Mikhail_Yuryevich" },
    full_name: "Черников Михаил Юрьевич",
    surname_en: "Chernikov",
    name_en: "Mikhail",
    lastname_en: "Yuryevich",
    work_position: "Начальник Главного управления по обеспечению безопасности дорожного движения МВД РФ",
    work_position_en:
        "Head of the Main Directorate for Road Safety of the Ministry of Internal Affairs of the Russian Federation",
    place_of_work: "",
    place_of_work_en: "",
};

const MISHUSTIN = {
    photo: { file: MishustinColor, name: "Mikhail Mishustin" },
    full_name: "Мишустин Михаил Владимирович",
    surname_en: "Mishustin",
    name_en: "Mikhail ",
    lastname_en: "",
    work_position: "Председатель Правительства Российской Федерации",
    work_position_en: "Prime Minister of the Russian Federation",
    place_of_work: "",
    place_of_work_en: "",
};

const SHADAYEV = {
    photo: { file: Shadayev_Maksut_Igorevich, name: "Shadayev_Maksut_Igorevich" },
    full_name: "Шадаев Максут Игоревич",
    surname_en: "Shadayev",
    name_en: "Maksut",
    lastname_en: "Igorevich",
    work_position: "Министр цифрового развития Российской Федерации",
    work_position_en: "Minister of Digital Development, Communications and Mass Media of the Russian Federation",
    place_of_work: "",
    place_of_work_en: "",
};

const BAKANOV = {
    photo: { file: Bakanov_Dmitry_Vladimirovich, name: "Bakanov_Dmitry_Vladimirovich" },
    full_name: "Баканов Дмитрий Владимирович",
    surname_en: "Bakanov",
    name_en: "Dmitry",
    lastname_en: "Vladimirovich",
    work_position: "Заместитель министра транспорта Российской Федерации",
    work_position_en: "Deputy Minister of Transport of the Russian Federation",
    place_of_work: "",
    place_of_work_en: "",
};

const DVORCOVICH = {
    photo: { file: Dvorkovich_Arkady_Vladimirovich, name: "Dvorkovich_Arkady_Vladimirovich" },
    full_name: "Дворкович Аркадий Владимирович",
    surname_en: "Dvorkovich",
    name_en: "Arkady",
    lastname_en: "Vladimirovich",
    work_position: "Председатель фонда «Сколково»",
    work_position_en: "",
    place_of_work: "",
    place_of_work_en: "",
};

const NURUTDINOV = {
    photo: { file: Nurutdinov_Airat_Rafkatovich, name: "Nurutdinov_Airat_Rafkatovich" },
    full_name: "Нурутдинов Айрат Рафкатович",
    surname_en: "Nurutdinov",
    name_en: "Airat",
    lastname_en: "Rafkatovich",
    work_position: "Генеральный директор ПАО «Таттелеком»",
    work_position_en: "CEO, Tattelecom",
    place_of_work: "",
    place_of_work_en: "",
};

// const URAZOV = {
//     photo: { file: Urazov_Robert_Nailevich, name: "Urazov_Robert_Nailevich" },
//     full_name: "Уразов Роберт Наилевич",
//     surname_en: "Urazov",
//     name_en: "Robert",
//     lastname_en: "Nailevich",
//     work_position: "Генеральный директор Агентства развития навыков и профессий",
//     work_position_en: "CEO, WorldSkills Russia",
//     place_of_work: "",
//     place_of_work_en: "",
// };

export const SPEAKERS: stringKeys = {
    "2020": [
        MINNIHAKHANOV,
        {
            photo: { file: ChernishenkoColor, name: "Dmitry Chernyshenko" },
            full_name: "Чернышенко Дмитрий Николаевич",
            surname_en: "Chernyshenko",
            name_en: "Dmitry",
            lastname_en: "",
            work_position: "Заместитель Председателя Правительства РФ",
            work_position_en: "",
            place_of_work: "",
            place_of_work_en: "",
        },
        {
            photo: { file: KhusnullinColor, name: "Marat Khusnullin" },
            full_name: "Хуснуллин Марат Шакирзянович",
            surname_en: "Khusnullin",
            name_en: "Marat",
            lastname_en: "",
            work_position: "Заместитель Председателя Правительства РФ",
            work_position_en: "",
            place_of_work: "",
            place_of_work_en: "",
        },
        CHERNIKOV,
        {
            photo: { file: Alafinov_Innokenty_Sergeevich, name: "Alafinov_Innokenty_Sergeevich" },
            full_name: "Алафинов Иннокентий Сергеевич",
            surname_en: "Alafinov",
            name_en: "Innokenty",
            lastname_en: "Sergeevich",
            work_position: "и.о. министра транспорта РФ",
            work_position_en: "",
            place_of_work: "",
            place_of_work_en: "",
        },
        {
            photo: { file: Skorobogatova_Olga_Nikolaevna, name: "Skorobogatova_Olga_Nikolaevna" },
            full_name: "Скоробогатова Ольга Николаевна",
            surname_en: "Skorobogatova",
            name_en: "Olga",
            lastname_en: "Nikolaevna",
            work_position: "Первый заместитель Председателя Центрального банка РФ",
            work_position_en: "",
            place_of_work: "",
            place_of_work_en: "",
        },
        {
            photo: { file: Aiden_Wu, name: "Aiden_Wu" },
            full_name: "Эйден У",
            surname_en: "Aiden",
            name_en: "Wu",
            lastname_en: "",
            work_position: "Президент компании Huawei в регионе Евразия",
            work_position_en: "",
            place_of_work: "",
            place_of_work_en: "",
        },
        {
            photo: { file: Jakob_Bangsgaard, name: "Jakob_Bangsgaard" },
            full_name: "Якоб Бангсгаард",
            surname_en: "Jakob",
            name_en: "Bangsgaard",
            lastname_en: "",
            work_position: "Генеральный директор Ассоциации «ЭРТИКО ИТС-ЕВРОПА» (Бельгия)",
            work_position_en: "",
            place_of_work: "",
            place_of_work_en: "",
        },
        DVORCOVICH,
        {
            photo: { file: Alexander_Stolyarov, name: "Alexander_Stolyarov" },
            full_name: "Столяров Александр Александрович",
            surname_en: "Stolyarov",
            name_en: "Alexander",
            lastname_en: "",
            work_position: "Заместитель генерального директора Huawei Enterprise в России",
            work_position_en: "",
            place_of_work: "",
            place_of_work_en: "",
        },
        {
            photo: { file: Guzairov_Aidar_Failevich, name: "Guzairov_Aidar_Failevich" },
            full_name: "Гузаиров Айдар Фаилевич",
            surname_en: "Guzairov",
            name_en: "Aidar",
            lastname_en: "Failevich",
            work_position: "Генеральный директор  группы компаний InnoSTage",
            work_position_en: "",
            place_of_work: "",
            place_of_work_en: "",
        },
    ],
    "2021": [
        MISHUSTIN,
        SHADAYEV,
        MINNIHAKHANOV,
        DVORCOVICH,
        {
            photo: { file: Ordzhonikidze_Grigory_Eduardovich, name: "Ordzhonikidze_Grigory_Eduardovich" },
            full_name: "Орджоникидзе Григорий Эдуардович",
            surname_en: "Ordzhonikidze",
            name_en: "Grigory",
            lastname_en: "Eduardovich",
            work_position: "Ответственный секретарь комиссии РФ по делам ЮНЕСКО",
            work_position_en: "",
            place_of_work: "",
            place_of_work_en: "",
        },
        {
            photo: { file: Zhou_Danjin, name: "Zhou_Danjin" },
            full_name: "Чжоу Даньцзинь",
            surname_en: "Zhou",
            name_en: "Danjin",
            lastname_en: "",
            work_position: "Президент Евразийского регионального представительства компании Huawei (Россия)",
            work_position_en: "",
            place_of_work: "",
            place_of_work_en: "",
        },
        {
            photo: { file: Jakob_Bangsgaard, name: "Jakob_Bangsgaard" },
            full_name: "Якоб Бангсгаард",
            surname_en: "Jakob",
            name_en: "Bangsgaard",
            lastname_en: "",
            work_position: "Генеральный директор Ассоциации «ЭРТИКО ИТС-ЕВРОПА» (Бельгия)",
            work_position_en: "",
            place_of_work: "",
            place_of_work_en: "",
        },
        {
            photo: { file: Marina_Alekseevna_Zhunich, name: "Marina_Alekseevna_Zhunich" },
            full_name: "Марина Алексеевна Жунич",
            surname_en: "Zhunich",
            name_en: "Marina",
            lastname_en: "Alekseevna",
            work_position: "Директор по взаимодействию с органами государственной власти компании «Google Россия»",
            work_position_en: "",
            place_of_work: "",
            place_of_work_en: "",
        },
        {
            photo: { file: Orlovsky_Viktor_Mikhailovich, name: "Orlovsky_Viktor_Mikhailovich" },
            full_name: "Орловский Виктор Михайлович",
            surname_en: "Orlovsky",
            name_en: "Viktor",
            lastname_en: "Mikhailovich",
            work_position: "Основатель и генеральный партнер  Fort Ross Ventures",
            work_position_en: "",
            place_of_work: "",
            place_of_work_en: "",
        },
    ],
    "2022": [
        MISHUSTIN,
        SHADAYEV,
        MINNIHAKHANOV,
        {
            photo: { file: Aksakov_Anatoly_Gennadievich, name: "Aksakov_Anatoly_Gennadievich" },
            full_name: "Аксаков Анатолий Геннадьевич",
            surname_en: "Aksakov",
            name_en: "Anatoly",
            lastname_en: "Gennadievich",
            work_position: "Председатель комитета по финансовому рынку ГД ФС РФ",
            work_position_en: "Chairman of the State Duma Committee on Financial Market",
            place_of_work: "",
            place_of_work_en: "",
        },
        CHERNIKOV,
        BAKANOV,
        {
            photo: { file: Dyubanov_Anatoly_Vasilievich, name: "Dyubanov_Anatoly_Vasilievich" },
            full_name: "Дюбанов Анатолий Васильевич",
            surname_en: "Dyubanov",
            name_en: "Anatoly",
            lastname_en: "Vasilievich",
            work_position: "Директор Департамента развития цифровой экономики Минэкономразвития России",
            work_position_en:
                "Director of the Digital Economy Development Department of the Ministry of Economic Development of Russia",
            place_of_work: "",
            place_of_work_en: "",
        },
        // URAZOV,
        {
            photo: { file: Kaem_Kirill_Vladimirovich, name: "Kaem_Kirill_Vladimirovich" },
            full_name: "Каем Кирилл Владимирович",
            surname_en: "Kaem",
            name_en: "Kirill",
            lastname_en: "Vladimirovich",
            work_position: "Старший вице-президент по инновациям, председатель грантового комитета фонда «Сколково»",
            work_position_en:
                "Senior Vice President for Innovations, Chairman of the Grants Committee of the Skolkovo Foundation",
            place_of_work: "",
            place_of_work_en: "",
        },
        NURUTDINOV,
        {
            photo: { file: Vitaliy_Terentyev, name: "Vitaliy_Terentyev" },
            full_name: "Терентьев Виталий Анатольевич",
            surname_en: "Terentyev",
            name_en: "Vitaliy",
            lastname_en: "",
            work_position: "GR-директор Head-Hunter",
            work_position_en: "GR-director, Head-Hunter",
            place_of_work: "",
            place_of_work_en: "",
        },
        {
            photo: { file: Nashchekin_Alexey_Sergeevich, name: "Nashchekin_Alexey_Sergeevich" },
            full_name: "Нащекин Алексей Сергеевич",
            surname_en: "Nashchekin",
            name_en: "Alexey",
            lastname_en: "Sergeevich",
            work_position: "Генеральный директор концерна «Телематика»",
            work_position_en: "CEO of the Telematika Corporation",
            place_of_work: "",
            place_of_work_en: "",
        },
    ],
    "2023": [
        MISHUSTIN,
        SHADAYEV,
        MINNIHAKHANOV,
        CHERNIKOV,
        BAKANOV,
        {
            photo: { file: Shpak_Vasiliy_Viktorovich, name: "Shpak_Vasiliy_Viktorovich" },
            full_name: "Шпак Василий Викторович",
            surname_en: "Shpak",
            name_en: "Vasiliy",
            lastname_en: "Viktorovich",
            work_position: "Заместитель министра промышленности и торговли РФ",
            work_position_en: "Deputy Minister of Industry and Trade of the Russian Federation",
            place_of_work: "",
            place_of_work_en: "",
        },
        {
            photo: { file: Prepodobnaya_Nadezhda_Aleksandrovna, name: "Prepodobnaya_Nadezhda_Aleksandrovna" },
            full_name: "Преподобная Надежда Александровна",
            surname_en: "Prepodobnaya",
            name_en: "Nadezhda",
            lastname_en: "Aleksandrovna",
            work_position: "Статс-секретарь-заместитель министра культуры РФ",
            work_position_en: "State Secretary-Deputy Minister of Culture of the Russian Federation",
            place_of_work: "",
            place_of_work_en: "",
        },
        // URAZOV,
        NURUTDINOV,
        {
            photo: { file: Sergiyenkov_Dmitriy_Sergeyevich, name: "Sergiyenkov_Dmitriy_Sergeyevich" },
            full_name: "Сергиенков Дмитрий Сергеевич",
            surname_en: "Sergiyenkov",
            name_en: "Dmitriy",
            lastname_en: "Sergeyevich",
            work_position: "Генеральный директор HeadHunter",
            work_position_en: "CEO of HeadHunter",
            place_of_work: "",
            place_of_work_en: "",
        },
        {
            photo: { file: Abakumov_Evgeniy_Mikhailovich, name: "Abakumov_Evgeniy_Mikhailovich" },
            full_name: "Абакумов Евгений Михайлович",
            surname_en: "Abakumov",
            name_en: "Evgeniy",
            lastname_en: "Mikhailovich",
            work_position: "Директор по информационным технологиям Государственной корпорации «Росатом»",
            work_position_en: 'Director of Information Technology of the State Corporation "Rosatom"',
            place_of_work: "",
            place_of_work_en: "",
        },
    ],
    "2024": [
        MISHUSTIN,
        SHADAYEV,
        MINNIHAKHANOV,
        // BAKANOV,
        NURUTDINOV,
        {
            photo: { file: Alekseeva_Zhanna_Vladimirovna, name: "Alekseeva_Zhanna_Vladimirovna" },
            full_name: "Алексеева Жанна Владимировна",
            surname_en: "Alekseeva",
            name_en: "Zhanna",
            lastname_en: "Vladimirovna",
            work_position: "Статс-секретарь - заместитель министра культуры Российской Федерации",
            work_position_en: "State Secretary - Deputy Minister of Culture of the Russian Federation",
            place_of_work: "",
            place_of_work_en: "",
        },
        {
            photo: { file: Omelchuk_Andrey_Vladimirovich, name: "Omelchuk_Andrey_Vladimirovich" },
            full_name: "Омельчук Андрей Владимирович",
            surname_en: "Omelchuk",
            name_en: "Andrey",
            lastname_en: "Vladimirovich",
            work_position: "Заместитель министра науки и высшего образования Российской Федерации",
            work_position_en: "Deputy Minister of Science and Higher Education of the Russian Federation",
            place_of_work: "",
            place_of_work_en: "",
        },
        {
            photo: { file: Akhmerov_Timur_Maratovich, name: "Akhmerov_Timur_Maratovich" },
            full_name: "Ахмеров Тимур Маратович",
            surname_en: "Akhmerov",
            name_en: "Timur",
            lastname_en: "Maratovich",
            work_position: "Генеральный директор АО «БАРС Групп»",
            work_position_en: "General Director of JSC BARS Group",
            place_of_work: "",
            place_of_work_en: "",
        },
        {
            photo: { file: Kulik_Vadim_Valerievich, name: "Kulik_Vadim_Valerievich" },
            full_name: "Кулик Вадим Валерьевич",
            surname_en: "Kulik",
            name_en: "Vadim",
            lastname_en: "Valerievich",
            work_position: "Заместитель Президента - Председатель Правления Банка ВТБ",
            work_position_en: "Deputy President - Chairman of the Management Board of VTB Bank",
            place_of_work: "",
            place_of_work_en: "",
        },
        {
            photo: { file: Kaspersky_Evgeny_Valentinovich, name: "Kaspersky_Evgeny_Valentinovich" },
            full_name: "Касперский Евгений Валентинович",
            surname_en: "Kaspersky",
            name_en: "Evgeny",
            lastname_en: "Valentinovich",
            work_position: "Генеральный директор АО «Лаборатория Касперского»",
            work_position_en: "CEO of JSC Kaspersky Lab",
            place_of_work: "",
            place_of_work_en: "",
        },
        {
            photo: { file: Zelenskiy_Vladimir, name: "Zelenskiy_Vladimir" },
            full_name: "Зеленский Владимир Анатольевич",
            surname_en: "Zelenskiy",
            name_en: "Vladimir",
            lastname_en: "",
            work_position: "Первый заместитель министра здравоохранения Российской Федерации",
            work_position_en: "First Deputy Minister of Health of the Russian Federation",
            place_of_work: "",
            place_of_work_en: "",
        },
    ],
};
